import {TextField, TextFieldProps} from "@mui/material";
import { IMaskInput } from 'react-imask';
import React, {forwardRef, useEffect, useRef, useState} from "react";


export type PhoneFieldProps = Omit<TextFieldProps, "onChange"> & {
    onChange?: (v: string) => void
}


function checkValue(value) {
    return /^\d{10}$/.test(value);
}

function normalizePhoneNumber(phoneNumber: string): string {
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    const normalized = digitsOnly.replace(/^7|8/, '');

    return normalized.slice(0, 10);
}

const FormatInput = forwardRef<HTMLInputElement, {onChange?: (v: string) => void, value?: string}>((props, ref) => {
    const {onChange, value: defaultValue, ...other} = props;
    const [value, setValue] = useState(defaultValue);
    const $input = useRef<HTMLInputElement>();

    useEffect(() => {
        if (checkValue(defaultValue)) {
            setValue(defaultValue);
        } else if (!defaultValue && checkValue(value)) {
            setValue(defaultValue);
        }
        if ($input.current) {
            // @ts-ignore
            $input.current.element.value = defaultValue;
        }
    }, [defaultValue])

    useEffect(() => {
        if (checkValue(value)) {
            onChange(value);
        } else if (defaultValue) {
            onChange("");
        }
    }, [value]);

    const onPaste = (e: ClipboardEvent) => {
        e.preventDefault();
        const paste = e.clipboardData.getData('text');
        setValue(normalizePhoneNumber(paste));
    }

    return (
        <IMaskInput
            {...other}
            // @ts-ignore
            ref={$input}
            // @ts-ignore
            value={value}
            // @ts-ignore
            mask="+{7} (000) 000-00-00"
            // @ts-ignore
            placeholder="+7 (000) 000-00-00"
            // @ts-ignore
            inputRef={ref}
            unmask={true}
            type="tel"
            onAccept={(value) => {
                // @ts-ignore
                setValue(value.substr(1));
            }}
            onPaste={onPaste}
            overwrite
        />
    )
})


export const PhoneField = (props: PhoneFieldProps) => {
    return (
        <TextField
            {...props as any}
            InputProps={{
                ...props?.InputProps,
                inputComponent: FormatInput as any
            }}
        />
    )
}
